import { createContext, useContext } from "react";

import type { FlightFare } from "@/features/flights/components/flight-fares/types";
import type {
  AdditionalServiceData,
  FlightOffer,
  FlightSearchType,
  MappedFlightOffer,
  ServicesSelection,
} from "@/features/flights/types/types";

type FlightPayload =
  | (FlightOffer & ServicesSelection & { upsellCode?: string | null })
  | null;

export interface FlightSelectionPayloadContextValue {
  selectedOfferIndex: string | null;
  selectedDepartureFlightId: string | null;
  selectedReturnFlightId: string | null;
  selectedFlightPayload: FlightPayload;
  selectedFlightSearchSource: FlightSearchType | null;
  handleDepartureFlightSelection: (
    offer: MappedFlightOffer,
    flightId: string,
    queryType: FlightSearchType | null,
  ) => void;
  handleReturnFlightSelection: (
    offer: MappedFlightOffer,
    flightId: string,
  ) => void;
  clearFlightSelection: () => void;
  getTravellerServices: (travellerId: string) => AdditionalServiceData[];
  setTravellerServices: (
    travellerId: string,
    service: AdditionalServiceData[],
  ) => void;
  removeTravellerServices: (travellerId: string) => void;
  promoCode: string | null;
  setPromoCode: (code: string | null) => void;
  selectedFare: FlightFare | null;
  setSelectedFare: (fare: FlightFare | null) => void;
}

export const FlightSelectionPayloadContext =
  createContext<FlightSelectionPayloadContextValue | null>(null);

export const useFlightSelectionPayloadContext = () => {
  const context = useContext(FlightSelectionPayloadContext);
  if (!context) {
    throw new Error(
      "useFlightSelectionPayloadContext must be used within a FlightSelectionPayloadContextProvider",
    );
  }
  return context;
};
